import React from "react";
import "./PremiumGameLoader.css";

const GAME_NAMES = {
  dice: "Dice",
  "color-prediction": "Color Prediction",
  "fortune-wheel": "Fortune Wheel",
  crash: "Crash",
  roulette: "Roulette",
  "andar-bahar": "Andar Bahar",
  "casino-dice": "Casino Dice",
  keno: "Keno",
  aviator: "Aviator",
  "4-in-a-row": "4 in a Row",
  mines: "Mines",
  plinko: "Plinko",
};

export const getGameNameFromPath = (pathname = "") => {
  const slug = pathname.split("/inhouse-games/")[1]?.split("/")[0];
  return GAME_NAMES[slug] || "In-House Game";
};

const CardMark = ({ children, className = "" }) => (
  <span className={`premium-game-loader__card-mark ${className}`} aria-hidden="true">
    {children}
  </span>
);

export default function PremiumGameLoader({ gameName = "In-House Game" }) {
  return (
    <div className="premium-game-loader" role="status" aria-live="polite">
      <div className="premium-game-loader__orb premium-game-loader__orb--one" />
      <div className="premium-game-loader__orb premium-game-loader__orb--two" />
      <div className="premium-game-loader__grid" aria-hidden="true" />

      <div className="premium-game-loader__content">
        <div className="premium-game-loader__brand">
          <span className="premium-game-loader__brand-dot" />
          ACE<span>ODDS</span>
        </div>

        <div className="premium-game-loader__table" aria-hidden="true">
          <div className="premium-game-loader__table-ring" />
          <div className="premium-game-loader__marks">
            <CardMark className="premium-game-loader__card-mark--red">♥</CardMark>
            <CardMark>♠</CardMark>
            <CardMark className="premium-game-loader__card-mark--red">♦</CardMark>
            <CardMark>♣</CardMark>
          </div>
          <div className="premium-game-loader__chip">ACE</div>
        </div>

        <p className="premium-game-loader__eyebrow">IN-HOUSE GAMES</p>
        <h1 className="premium-game-loader__title">{gameName}</h1>
        <p className="premium-game-loader__message">Preparing your table</p>
        <p className="premium-game-loader__hint">Connecting securely to the game</p>

        <div className="premium-game-loader__progress" aria-hidden="true">
          <span />
        </div>
        <div className="premium-game-loader__status">
          <span className="premium-game-loader__status-dot" />
          Loading game data
        </div>
      </div>
    </div>
  );
}
